var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wholeContext"},[_c('div',{staticClass:"appContext"},[_c('div',{staticClass:"scarListWrap"},[_c('input',{staticClass:"boneImg",attrs:{"type":"file","multiple":""},on:{"change":_vm.onFileChange}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }